import { render, staticRenderFns } from "./EditorDebugConsole.vue?vue&type=template&id=0070f15a"
import script from "./EditorDebugConsole.vue?vue&type=script&lang=js"
export * from "./EditorDebugConsole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports